// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"821280fa","97":"b07d3d65","207":"dc62f6a6","268":"1389e62c","429":"cc1ee527","488":"b1d4599f","583":"cf8c5883","632":"c4efeffb","741":"55b4fdcd","872":"6997b1d2","947":"f9b953e0"}[chunkId] + ".chunk.js";
};